import Dispatcher from 'core/Dispatcher';
import Constants from 'constants.js';
import LoggedUserService from 'services/LoggedUserService';

class LoggedUserAction {

    changeCurrentLanguage(language) {
        if (language) {
            Dispatcher.dispatch({
                actionType: Constants.CHANGE_LANGUAGE,
                value: {
                    language
                }
            });
        }
    }

    initRights() {
        return LoggedUserService.getRights().then(response => {
            Dispatcher.dispatch({
                actionType: Constants.INIT_RIGHTS,
                value: response
            });
            return true;
        });
    }
}

export default new LoggedUserAction();
